import { ChannelApi } from '@rbx/clients/clientSettingsApi/v2';
import { getBEDEV1ServiceBasePath } from '@modules/utilities/constants/baseUrl';
import { Configuration } from '@rbx/clients';

class ClientSettingsClient {
  private api: ChannelApi;

  constructor(basePath: string = getBEDEV1ServiceBasePath('clientsettings')) {
    const defaultConfig = new Configuration({
      basePath,
      credentials: 'include',
    });

    this.api = new ChannelApi(defaultConfig);
  }

  async getUserChannel(binaryType: string): Promise<string> {
    const { channelName } = await this.api.v2UserChannelGet({ binaryType });
    return channelName ?? '';
  }
}

export default new ClientSettingsClient();
